import { CPUModule } from 'game/components/modules/CPUModule';
import { DoorModuleComponent } from 'game/components/modules/DoorModule';
import { FollowModuleComponent } from 'game/components/modules/FollowModule';
import { InventoryModuleComponent } from 'game/components/modules/InventoryModule';
import { LogicModule } from 'game/components/modules/LogicModule';
import { ModuleComponentProps } from 'game/components/modules/ModuleProps';
import { MoveToModuleComponent } from 'game/components/modules/MoveToModule';
import { NearbyModuleComponent } from 'game/components/modules/NearbyModule';
import { ScannerModuleComponent } from 'game/components/modules/ScannerModule';
import { UseModuleComponent } from 'game/components/modules/UseModule';
import { ModuleType } from 'game/state/BotState';

export const BotModule: React.FC<ModuleComponentProps<ModuleType>> = props => {
  const { module } = props;
  switch (module.type) {
    case ModuleType.Cpu: return <CPUModule />;
    case ModuleType.Inventory: return <InventoryModuleComponent {...props} module={module} />;
    case ModuleType.Nearby: return <NearbyModuleComponent {...props} module={module} />;
    case ModuleType.Use: return <UseModuleComponent {...props} module={module} />;
    case ModuleType.Logic: return <LogicModule {...props} module={module} />;
    case ModuleType.MoveTo: return <MoveToModuleComponent {...props} module={module} />;
    case ModuleType.Follow: return <FollowModuleComponent {...props} module={module} />;
    case ModuleType.Scanner: return <ScannerModuleComponent {...props} module={module} />;
    case ModuleType.Door: return <DoorModuleComponent {...props} module={module} />;
  }
};
